{
	"it": {
		"uploading": "Upload in corso",
		"wait_for_upload": "Attendi il caricamento delle immagini ([0])",
		"upload_complete": "Caricamento completato",
		"upload_error": "Errore nel caricamento",
		"upload_error_file_too_big": "Il file è troppo grande. La dimensione massima consentita è 5MB",
		"n_selected": "[0] selezionati",
		"1_selected": "1 selezionato",
		"drag_to_sort": "Trascina per ordinare",
		"add_item": "Aggiungi elemento",
		"save": "Salva",
		"select_placeholder": "Seleziona",
		"read_the_contract": "Leggi il contratto",
		"accept_contract": "Accetta il contratto",
		"read_more": "Leggi di più...",
		"accept_general_conditions": "Accetta il contratto per proseguire",
		"state_failed": "Generazione fattura fallita",
		"state_refused": "Fattura rifiutata dal SDI",
		"state_normal": "Fattura standard inviata",
		"state_electronic": "Fattura elettronica in gestione",
		"state_manual": "Fattura emessa manualmente",
		"state_confirmed": "Fattura confermata dal SDI",
		"state_refund_requested": "Rimborso in gestione",
		"state_refund_failed": "Generazione fallita",
		"state_refunded": "Stornata",
		"credit_note_requested": "In gestione",
		"credit_note_issued": "Confermata dal SDI",
		"invoice_type_commissions_stripe": "Commissioni Stripe",
		"invoice_type_commissions_pos": "Commissioni POS",
		"invoice_type_commissions_other": "Commissioni altri metodi",
		"invoice_type_commissions_payout": "Commissioni instant payout",
		"invoice_type_shop": "Ordine shop",
		"invoice_type_super_invoice": "Fattura super",
		"invoice_type_subscription": "Abbonamento",
		"credit_note": "Nota di credito",
		"invoice": "Fattura",
		"state_canceled": "Fattura annullata",
		"transactions": "Transazioni",
		"birthday": "Compleanno",
		"anniversary": "Anniversario",
		"business_reason": "Business",
		"honeymoon": "Luna di miele",
		"graduation": "Laurea",
		"bitcoin": "Bitcoin",
		"satispay": "Satispay",
		"klarna": "Klarna",
		"voucherly": "Buoni pasto",
		"stripe": "Carte",
		"btc": "Bitcoin",
		"civic": "Civico",
		"zip": "CAP",
		"street": "Via",
		"city": "Comune",
		"province": "Provincia",
		"province_code": "Sigla provincia",
		"region": "Regione",
		"country_field": "Paese",
		"edit_address_fields": "Modifica indirizzo",
		"edit_address_fields_caption": "Completa o correggi i campi dell'indirizzo.",
		"map_position": "Posizione",
		"pin_map_caption": "Tocca la mappa o trascina il segnalino per indicare la posizione desiderata.",
		"pin_map_description": "Sposta il segnalino per selezionare le coordinate precise dell'indirizzo.",
		"use_current_position": "Usa la posizione attuale",
		"geolocation_permission_denied": "Permesso di geolocalizzazione negato. Abilita l'accesso alla posizione dalle impostazioni del browser.",
		"geolocation_unavailable": "Impossibile determinare la posizione attuale. Riprova.",
		"confirm": "Conferma",
		"cancel": "Annulla",
		"show": "Mostra",
		"hide": "Nascondi",
		"copied": "Copiato!",
		"erase_filters": "Filtri",
		"rating_1": "Scarso",
		"rating_2": "Medio",
		"rating_3": "Buono",
		"rating_4": "Molto buono",
		"rating_5": "Eccellente",
		"forecast_delivery": "Consegna prevista [0]",
		"forecast_preparation": "Il tuo ordine sarà pronto [0]",
		"fail_nfc_connection": "Connessione sicura al POS non riuscita.",
		"tap_phone_ios": "Tap to Pay su iPhone",
		"last_24_hours": "Ultime 24 ore",
		"last_7_days": "Ultimi 7 giorni",
		"last_30_days": "Ultimi 30 giorni",
		"last_365_days": "Ultimi 365 giorni",
		"generic_error": "Si è verificato un errore. Riprova o contatta l'assistenza.",
		"counter": "Gestionale",
		"volume_types_chart": "Totale per metodo di pagamento",
		"orders_types_chart": "Ordini per metodo di pagamento",
		"volume_mode_chart": "Totale per tipologia ordine",
		"orders_mode_chart": "Ordini per tipologia ordine",
		"card_network_volume": "Totale per circuito carte",
		"card_network_orders": "Ordini per circuito carte",
		"card_funding_volume": "Totale per tipo carta",
		"card_funding_orders": "Ordini per tipo carta",
		"multi_payment": "Multi pagamento",
		"failed_invoice": "Fattura fallita",
		"allergens_filter": "Filtro allergeni",
		"ask_for_assistance": "Chiama assistenza",
		"incoming_assistance": "Assistenza in arrivo",
		"call_placed": "Chiamata effettuata",
		"ask_for_assistance_info": "[0] ha ricevuto la tua richiesta e arriverà ad assisterti il prima possibile.",
		"unsupported_browser": "Questo browser non è supportato. Apri il link in un browser standard come Safari, Firefox, Chrome.",
		"menu": "Menù",
		"catalog": "Catalogo",
		"wire": "Bonifico",
		"external": "Esterno",
		"pm_external": "Esterno",
		"check": "Assegno",
		"ticket": "Ticket",
		"paylater": "Non riscosso",
		"customer_credit": "Credito cliente",
		"week_letter": "s",
		"1_week": "1 settimana",
		"4_weeks": "4 settimane",
		"this_month": "Questo mese",
		"delivery": "Delivery",
		"delivery_other": "Consegna",
		"takeaway": "Asporto",
		"takeaway_other": "Ritiro",
		"3_months": "3 mesi",
		"6_months": "6 mesi",
		"1_year": "1 anno",
		"this_year": "Quest'anno",
		"soon": "a breve",
		"caps_now": "ADESSO",
		"in_x_min": "tra [0] min",
		"in_x_hour": "tra [0] ore",
		"today_at": "oggi alle [0]",
		"tomorrow_at": "domani alle [0]",
		"in_x_days": "tra [0] giorni",
		"in_1_hour_x_min": "tra 1 ora e [0] min",
		"in_x_hours_y_min": "tra [0] ore e [1] min",
		"total_pagination": "Totale: [0]",
		"business_is_subscribed": "Attività già iscritta",
		"restaurant": "Ristorante",
		"food_and_beverage": "Food and Beverage",
		"events": "Eventi",
		"bar": "Bar o Pub",
		"beach": "Stabilimento balneare",
		"other": "Altro",
		"retail": "Retail",
		"ok": "Ok",
		"copy": "Copia",
		"apply": "Applica",
		"back": "Indietro",
		"items_per_page": "Elementi per pagina",
		"next": "Avanti",
		"success": "Successo",
		"operation_completed": "Operazione completata",
		"action": "Azione",
		"error": "Errore",
		"room": "Sala",
		"warning": "Attenzione",
		"no_result": "Nessun risultato",
		"total_x": "Totale: [0]",
		"x_min": "[0] min",
		"x_min_ago": "[0] min fa",
		"x_hours": "[0] ore",
		"x_hours_ago": "[0] ore fa",
		"x_days": "[0] giorni",
		"x_days_ago": "[0] giorni fa",
		"missing_data": "Nessun dato disponibile.",
		"allergens_celery": "Sedano",
		"allergens_clams": "Molluschi",
		"allergens_dioxide": "Solfiti",
		"allergens_egg": "Uova",
		"allergens_fish": "Pesce",
		"allergens_lupins": "Lupini",
		"allergens_gluten": "Glutine",
		"allergens_milk": "Latte",
		"allergens_mustard": "Senape",
		"allergens_peanuts": "Arachidi",
		"allergens_sesame": "Sesamo",
		"allergens_shellfish": "Crostacei",
		"allergens_soia": "Soia",
		"allergens_wot": "Fr. guscio",
		"allergens_almond": "Mandorle",
		"allergens_barley": "Orzo",
		"allergens_brazil_nuts": "Noci brasiliane",
		"allergens_cashew": "Anacardi",
		"allergens_hazelnuts": "Nocciole",
		"allergens_macadamia": "Macadamia",
		"allergens_oats": "Avena",
		"allergens_pecan": "Noce pecan",
		"allergens_pistachios": "Pistacchi",
		"allergens_rye": "Segale",
		"allergens_spelt": "Farro",
		"allergens_walnuts": "Noci",
		"allergens_wheat": "Grano",
		"allergens_alcohol": "Alcol",
		"allergens_halal": "Halal",
		"allergens_kosher": "Kosher",
		"allergens_vegan": "Vegano",
		"allergens_vegetarian": "Vegetariano",
		"allergens_no_allergens": "Nessun allergene",
		"allergens_gluten_free": "Senza glutine",
		"allergens_kamut": "Kamut",
		"allergens_frost": "Congelato",
		"allergens_super_frost": "Abbattuto",
		"allergens_bio": "Bio",
		"allergens_spicy": "Piccante",
		"try_later_error": "Si è verificato un errore. Riprova più tardi.",
		"required_update": "Aggiornamento richiesto",
		"explain_bluetooth_update": "Aggiornamento del POS in corso, non chiudere l'applicazione",
		"saved": "Salvato",
		"changes_saved": "Modifiche salvate con successo",
		"no": "No",
		"yes": "Sì",
		"notification_sound": "Suono notifica",
		"bell_1": "Campanella 1",
		"bell_2": "Campanella 2",
		"door_bell": "Campanello",
		"chicken": "Gallina",
		"alarm_clock": "Sveglia",
		"notification_1": "Notifica 1",
		"notification_2": "Notifica 2",
		"notification_3": "Notifica 3",
		"notification_4": "Notifica 4",
		"notification_5": "Notifica 5",
		"none": "Nessuna",
		"contract_accept_1": "Dichiaro di aver preso visione e di accettare le Condizioni Generali.",
		"contract_accept_2": "Dichiaro espressamente di accettare il contenuto degli Articoli 3.2, 4, 5.4, 7.1, 7.2, 7.6, 8, 9.2, 9.3, 11.2, 14, 15, 16, 22 delle Condizioni Generali.",
		"chosen_font": "Scegli un Font",
		"test_the_font": "Prova il font",
		"banner_image": "Immagine banner",
		"currency_eur": "Euro",
		"currency_usd": "Dollari",
		"currency_gbp": "Sterline",
		"currency_aed": "Dirham",
		"currency_chf": "Franchi"
	},
	"en": {
		"caps_now": "NOW",
		"uploading": "Uploading...",
		"wait_for_upload": "Waiting for the upload of the images ([0])",
		"upload_complete": "Upload complete",
		"upload_error": "Error uploading",
		"upload_error_file_too_big": "File is too large. Maximum allowed size is 5MB",
		"n_selected": "[0] selected",
		"1_selected": "1 selected",
		"drag_to_sort": "Drag to sort",
		"add_item": "Add item",
		"save": "Save",
		"select_placeholder": "Select",
		"read_the_contract": "Read the contract",
		"accept_contract": "Accept Contract",
		"read_more": "Read More...",
		"accept_general_conditions": "Accept the contract before continuing",
		"state_failed": "Failed to generate invoice",
		"state_refused": "Invoice refused by SDI",
		"state_normal": "Standard invoice sent",
		"state_electronic": "Electronic invoice pending",
		"state_manual": "Invoice emitted manually",
		"state_confirmed": "Invoice confirmed by SDI",
		"state_refund_requested": "Refund pending",
		"state_refund_failed": "Generation failed",
		"state_refunded": "Reversed",
		"credit_note_requested": "Pending",
		"credit_note_issued": "Confirmed by SDI",
		"invoice_type_commissions_stripe": "Stripe commissions",
		"invoice_type_commissions_pos": "POS commissions",
		"invoice_type_commissions_other": "Other payment commissions",
		"invoice_type_commissions_payout": "Instant payout commissions",
		"invoice_type_shop": "Shop order",
		"invoice_type_super_invoice": "Super invoice",
		"invoice_type_subscription": "Subscription",
		"credit_note": "Credit note",
		"invoice": "Invoice",
		"state_canceled": "Invoice canceled",
		"transactions": "Transactions",
		"birthday": "Birthday",
		"anniversary": "Anniversary",
		"business_reason": "Business",
		"honeymoon": "Honeymoon",
		"graduation": "Graduation",
		"bitcoin": "Bitcoin",
		"satispay": "Satispay",
		"klarna": "Klarna",
		"voucherly": "Meal vouchers",
		"stripe": "Cards",
		"btc": "Bitcoin",
		"civic": "Civic",
		"zip": "Zip",
		"street": "Street",
		"city": "City",
		"province": "Province",
		"province_code": "Province code",
		"region": "Region",
		"country_field": "Country",
		"edit_address_fields": "Edit address",
		"edit_address_fields_caption": "Fill in or correct the address fields.",
		"map_position": "Position",
		"pin_map_caption": "Tap the map or drag the pin to indicate the desired position.",
		"pin_map_description": "Move the dropped pin to select the precise coordinates of the address.",
		"use_current_position": "Use current position",
		"geolocation_permission_denied": "Location permission denied. Enable location access in your browser settings.",
		"geolocation_unavailable": "Unable to determine your current position. Please try again.",
		"confirm": "Confirm",
		"cancel": "Cancel",
		"show": "Show",
		"hide": "Hide",
		"copied": "Copied!",
		"erase_filters": "Filters",
		"rating_1": "Poor",
		"rating_2": "Fair",
		"rating_3": "Good",
		"rating_4": "Very good",
		"rating_5": "Excellent",
		"forecast_delivery": "Scheduled delivery [0]",
		"forecast_preparation": "Your order will be ready [0]",
		"fail_nfc_connection": "Secure connection to the Terminal failed.",
		"tap_phone_ios": "Tap to Pay on iPhone",
		"last_24_hours": "Last 24 hours",
		"last_7_days": "Last 7 days",
		"last_30_days": "Last 30 days",
		"last_365_days": "Last 365 days",
		"generic_error": "An error occurred. Try again or contact support.",
		"counter": "Point of sale",
		"volume_types_chart": "Volume per payment method",
		"orders_types_chart": "Orders per payment method",
		"volume_mode_chart": "Volume per order mode",
		"orders_mode_chart": "Orders per order mode",
		"card_network_volume": "Card network volume",
		"card_network_orders": "Card network orders",
		"card_funding_volume": "Card funding volume",
		"card_funding_orders": "Card funding orders",
		"multi_payment": "Multi payment",
		"failed_invoice": "Failed to generate invoice",
		"allergens_filter": "Allergens filter",
		"ask_for_assistance": "Ask for assistance",
		"incoming_assistance": "Incoming assistance",
		"call_placed": "Call placed",
		"ask_for_assistance_info": "[0] received your request and will come to your assistance as soon as possible.",
		"unsupported_browser": "This browser is not supported. Please open the link in a standard browser like Safari, Firefox, Chrome.",
		"menu": "Menu",
		"catalog": "Catalog",
		"wire": "Wire transfer",
		"external": "External",
		"pm_external": "External",
		"check": "Check",
		"ticket": "Ticket",
		"paylater": "Pay later",
		"customer_credit": "Customer credit",
		"week_letter": "w",
		"1_week": "1 week",
		"4_weeks": "4 weeks",
		"this_month": "Current month",
		"delivery": "Delivery",
		"delivery_other": "Delivery",
		"takeaway": "Takeaway",
		"takeaway_other": "Pickup",
		"3_months": "3 months",
		"6_months": "6 months",
		"1_year": "1 year",
		"this_year": "Current year",
		"soon": "soon",
		"x_min": "[0] min",
		"x_min_ago": "[0] min ago",
		"x_hours": "[0] hours",
		"x_hours_ago": "[0] hours ago",
		"x_days": "[0] days",
		"x_days_ago": "[0] days ago",
		"in_x_min": "in [0] min",
		"in_x_hour": "in [0] hours",
		"today_at": "today at [0]",
		"tomorrow_at": "tomorrow at [0]",
		"in_x_days": "in [0] days",
		"in_1_hour_x_min": "in 1 hour and [0] min",
		"in_x_hours_y_min": "in [0] hours and [1] min",
		"total_pagination": "Total: [0]",
		"business_is_subscribed": "Business already subscribed",
		"restaurant": "Restaurant",
		"food_and_beverage": "Food and Beverage",
		"events": "Events",
		"bar": "Bar or Pub",
		"beach": "Resort Beach",
		"other": "Other",
		"retail": "Retail",
		"ok": "Ok",
		"copy": "Copy",
		"apply": "Apply",
		"back": "Back",
		"items_per_page": "Items per page",
		"next": "Next",
		"success": "Success",
		"operation_completed": "Operation completed",
		"action": "Action",
		"error": "Error",
		"room": "Sala",
		"warning": "Warning",
		"no_result": "No result",
		"total_x": "Total: [0]",
		"missing_data": "No data available.",
		"allergens_celery": "Celery",
		"allergens_clams": "Clams",
		"allergens_dioxide": "Sulphites",
		"allergens_egg": "Egg",
		"allergens_fish": "Fish",
		"allergens_lupins": "Lupins",
		"allergens_gluten": "Gluten",
		"allergens_milk": "Milk",
		"allergens_mustard": "Mustard",
		"allergens_peanuts": "Peanuts",
		"allergens_sesame": "Sesame",
		"allergens_shellfish": "Shellfish",
		"allergens_soia": "Soy",
		"allergens_wot": "Nuts",
		"allergens_almond": "Almonds",
		"allergens_barley": "Barley",
		"allergens_brazil_nuts": "Brazilian nuts",
		"allergens_cashew": "Cashew",
		"allergens_hazelnuts": "Hazelnuts",
		"allergens_macadamia": "Macadamia",
		"allergens_oats": "Oats",
		"allergens_pecan": "Pecan",
		"allergens_pistachios": "Pistachios",
		"allergens_rye": "Rye",
		"allergens_spelt": "Spelt",
		"allergens_walnuts": "Walnuts",
		"allergens_wheat": "Wheat",
		"allergens_alcohol": "Alcohol",
		"allergens_halal": "Halal",
		"allergens_kosher": "Kosher",
		"allergens_vegan": "Vegan",
		"allergens_vegetarian": "Vegetarian",
		"allergens_no_allergens": "No allergens",
		"allergens_gluten_free": "Gluten free",
		"allergens_kamut": "Kamut",
		"allergens_frost": "Frost",
		"allergens_super_frost": "Blast frozen",
		"allergens_bio": "Organic",
		"allergens_spicy": "Spicy",
		"try_later_error": "An error has occurred. Please try again later.",
		"required_update": "Update required",
		"explain_bluetooth_update": "Updating terminal, do not close the application",
		"saved": "Saved",
		"changes_saved": "Changes saved successfully",
		"no": "No",
		"yes": "Yes",
		"notification_sound": "Notification sound",
		"bell_1": "Bell 1",
		"bell_2": "Bell 2",
		"door_bell": "Door bell",
		"chicken": "Chicken",
		"alarm_clock": "Alarm clock",
		"notification_1": "Notification 1",
		"notification_2": "Notification 2",
		"notification_3": "Notification 3",
		"notification_4": "Notification 4",
		"notification_5": "Notification 5",
		"none": "none",
		"contract_accept_1": "I declare that I have read and accept the General Conditions.",
		"contract_accept_2": "I expressly declare that I accept the content of Articles 3.2, 4, 5.4, 7.1, 7.2, 7.6, 8, 9.2, 9.3, 11.2, 14, 15, 16, 22 of the General Conditions.",
		"chosen_font": "Choose a Font",
		"test_the_font": "Test the font",
		"banner_image": "Banner image",
		"currency_eur": "Euro",
		"currency_usd": "Dollars",
		"currency_gbp": "Pounds",
		"currency_aed": "Dirham",
		"currency_chf": "Francs"
	}
}